import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { TOOL_GROUPS, TOOLS, toolPath } from "@/data/tools";

const TINT = { calm: "#F3EEFC", sleep: "#E3E9FB", worry: "#FFF4DF", anger: "#E3F1FA", check: "#E9F6EC" };

const BY_GROUP = TOOLS.reduce((acc, t) => ({ ...acc, [t.group]: [...(acc[t.group] || []), t] }), {});

export default function ToolsHub() {
  usePageMeta({ title: "Free calm tools: breathing, grounding, stress check | Mindful Me",
    description: "Free calm tools you can use right now, no sign-up: box breathing, 4-7-8 breathing for sleep, 5-4-3-2-1 grounding, a worry dump, and a free stress check.", path: "/tools" });
  return (
    <PublicLayout>
      <section className="max-w-6xl mx-auto px-5 sm:px-8 pt-12 pb-20" data-testid="tools-hub">
        <span className="mm-chip !cursor-default !text-xs">Free · No sign-up · Nothing saved</span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mt-4 max-w-3xl">Free calm tools for right now</h1>
        <p className="text-mm-muted mt-4 max-w-2xl">Breathing, grounding and quick check-ins that work in your browser in a minute or two. Pick what you need.</p>
        {TOOL_GROUPS.map(([g, label]) => (
          <div key={g} className="mt-12" data-testid={`tools-group-${g}`}>
            <h2 className="text-xl font-bold">{label}</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 mm-stagger">
              {(BY_GROUP[g] || []).map((t) => (
                <Link key={t.slug} to={toolPath(t)} className="group rounded-[28px] p-6 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg" style={{ background: TINT[g] }} data-testid={`tools-card-${t.slug}`}>
                  <div className="flex items-start justify-between"><span className="text-3xl transition-transform group-hover:scale-110" aria-hidden>{t.emoji}</span><span className="text-xs font-bold rounded-full bg-white/80 px-2.5 py-1">{t.mins}</span></div>
                  <h3 className="font-bold text-lg mt-4">{t.name}</h3>
                  <p className="text-sm text-[#3A2E4F]/75 mt-1">{t.helps}</p>
                </Link>
              ))}
            </div>
          </div>
        ))}
        <div className="mt-16 rounded-[28px] p-8 bg-[#3A2E4F] text-white" data-testid="tools-hub-invite">
          <h2 className="text-2xl font-bold">Want tools that learn what helps you?</h2>
          <p className="text-white/80 mt-2 max-w-2xl">Mindful Me has 100+ tools like these, daily check-ins, Mia your calm companion, and a personal playbook built from your own data. One payment, yours for life.</p>
          <div className="flex flex-wrap gap-3 mt-5">
            <Link to="/pricing" className="mm-btn !bg-white !text-[#3A2E4F]" data-testid="tools-hub-pricing">See pricing</Link>
            <Link to="/embed" className="mm-btn-ghost !text-white !border-white/40" data-testid="tools-hub-embed">Add a breathing widget to your site</Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
